<div class="algorithm-schedule" [formGroup]="parent">
  @if (!editMode) {
    <div class="mode-selector" role="radiogroup">
      <label
        class="mode-option"
        [class.is-selected]="!parent.get('schedule')?.value"
      >
        <!-- scanner-disable-next-line R6 -- hidden carrier behind the native-by-design mode card, pending sui-button-group item projection (WAP-1568) -->
        <input type="radio" [value]="false" formControlName="schedule" />
        <span class="mode-option__icon">
          <fa-icon [icon]="['fas', 'play']"></fa-icon>
        </span>
        <span class="mode-option__body">
          <span class="mode-option__title">
            {{ "post-algorithm.form.execute-now" | translate }}
          </span>
          <span class="mode-option__hint">
            {{ "post-algorithm.form.execute-now-hint" | translate }}
          </span>
        </span>
      </label>

      <label
        class="mode-option"
        [class.is-selected]="parent.get('schedule')?.value"
      >
        <!-- scanner-disable-next-line R6 -- hidden carrier behind the native-by-design mode card, pending sui-button-group item projection (WAP-1568) -->
        <input type="radio" [value]="true" formControlName="schedule" />
        <span class="mode-option__icon">
          <fa-icon [icon]="['fas', 'clock']"></fa-icon>
        </span>
        <span class="mode-option__body">
          <span class="mode-option__title">
            {{ "post-algorithm.form.schedule" | translate }}
          </span>
          <span class="mode-option__hint">
            {{ "post-algorithm.form.schedule-hint" | translate }}
          </span>
        </span>
      </label>
    </div>
  }

  @if (scheduleEnabled) {
    <div class="recurrence-picker" [formGroup]="picker">
      <div class="recurrence-types" role="radiogroup">
        @for (option of typeOptions; track option.value) {
          <label
            class="recurrence-type"
            [class.is-selected]="pickerType === option.value"
          >
            <!-- scanner-disable-next-line R6 -- hidden carrier behind the recurrence-type chip picker, pending sui-button-group item projection (WAP-1568) -->
            <input type="radio" [value]="option.value" formControlName="type" />
            <span>{{ option.labelKey | translate }}</span>
          </label>
        }
      </div>

      @if (pickerType === "interval") {
        <div class="recurrence-row">
          <label for="algorithm-schedule-interval" sui-label>
            {{ "schedule-editor.label.send-on-every" | translate }}
          </label>
          <sui-input
            id="algorithm-schedule-interval"
            type="number"
            formControlName="interval_value"
            [min]="1"
          ></sui-input>
          <select class="recurrence-select" formControlName="interval_unit">
            <option value="minutes">
              {{ "schedule-editor.form-option.minutes" | translate }}
            </option>
            <option value="hours">
              {{ "schedule-editor.form-option.hours" | translate }}
            </option>
          </select>
        </div>
      }

      @if (
        pickerType === "daily" ||
        pickerType === "weekly" ||
        pickerType === "monthly"
      ) {
        <div class="recurrence-row">
          <label for="algorithm-schedule-time" sui-label>
            {{ "schedule-editor.label.time-of-day-to-send" | translate }}
          </label>
          <input
            id="algorithm-schedule-time"
            class="recurrence-time"
            type="time"
            formControlName="time_of_day"
          />
        </div>
      }

      @if (pickerType === "weekly") {
        <div class="recurrence-row">
          <label sui-label>
            {{ "schedule-editor.label.send-on" | translate }}
          </label>
          <div class="recurrence-weekdays">
            @for (weekday of weekdayOptions; track weekday.id) {
              <label
                class="recurrence-weekday"
                [class.is-selected]="isWeekdaySelected(weekday.id)"
              >
                <!-- scanner-disable-next-line R6 -- hidden carrier behind the weekday chip picker, pending sui-button-group item projection (WAP-1568) -->
                <input
                  type="checkbox"
                  [checked]="isWeekdaySelected(weekday.id)"
                  (change)="toggleWeekday(weekday.id)"
                />
                <span>{{ weekday.key | translate }}</span>
              </label>
            }
          </div>
        </div>
      }

      @if (pickerType === "monthly") {
        <div class="recurrence-row">
          <label for="algorithm-schedule-day-of-month" sui-label>
            {{ "schedule-editor.label.day-of-month-to-send" | translate }}
          </label>
          <select
            id="algorithm-schedule-day-of-month"
            class="recurrence-select"
            formControlName="day_of_month"
          >
            @for (day of dayOfMonthOptions; track day.value) {
              <option [ngValue]="day.value">
                {{
                  day.value === 0
                    ? ("schedule-editor.form-option.last-day-of-month"
                      | translate)
                    : day.label
                }}
              </option>
            }
          </select>
        </div>
      }

      @if (pickerType === "cron") {
        <div class="recurrence-row">
          <label for="algorithm-schedule-cron" sui-label>
            {{ "schedule-editor.label.cron-expression" | translate }}
          </label>
          <sui-input
            id="algorithm-schedule-cron"
            type="text"
            formControlName="cron_expression"
            placeholder="*/15 * * * *"
          ></sui-input>
        </div>
      }

      @if (pickerType !== "interval") {
        <div class="recurrence-row">
          <label for="algorithm-schedule-timezone" sui-label>
            {{ "schedule-editor.label.schedule-timezone" | translate }}
          </label>
          <select
            id="algorithm-schedule-timezone"
            class="recurrence-select"
            formControlName="timezone_id"
          >
            <option [ngValue]="null">
              {{ "schedule-editor.form-option.system-timezone" | translate }}
            </option>
            @for (timezone of timezones; track timezone.id) {
              <option [ngValue]="timezone.id">{{ timezone.name }}</option>
            }
          </select>
        </div>
      }
    </div>
  }
</div>
